// Meoks: Ürün kartlarında renk kardeşi yükleyici (Storefront Search API)
// 1M+ ürün ölçeklenebilir — tag-indexed search kullanır
(function () {
  var CACHE = {};
  function loadFor(el) {
    if (el.dataset.loaded === '1') return;
    el.dataset.loaded = '1';
    var mk = el.getAttribute('data-mk');
    var currentId = el.getAttribute('data-current-id');
    if (!mk) return;
    function render(results) {
      var html = '';
      var count = 0;
      (results || []).forEach(function (p) {
        if (count >= 6) return;
        var thisId = p.id && ('gid://shopify/Product/' + p.id);
        if (thisId && thisId === currentId) return;
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        html += '<a href="/products/' + p.handle + '" class="meoks-card-colors__swatch" title="' + (p.title || '').replace(/"/g, '&quot;') + '" onclick="event.stopPropagation();">';
        if (img) html += '<img src="' + img + '" alt="" width="38" height="38" loading="lazy">';
        html += '</a>';
        count++;
      });
      if (!html) {
        var selfImg = el.getAttribute('data-self-img');
        var selfHandle = el.getAttribute('data-self-handle');
        var selfTitle = el.getAttribute('data-self-title') || '';
        if (selfImg && selfHandle) {
          html = '<a href="/products/' + selfHandle + '" class="meoks-card-colors__swatch" title="' + selfTitle.replace(/"/g, '&quot;') + '" onclick="event.stopPropagation();">'
               + '<img src="' + selfImg + '" alt="" width="38" height="38" loading="lazy"></a>';
        }
      }
      if (html) el.innerHTML = html;
    }
    if (CACHE[mk]) { render(CACHE[mk]); return; }
    // Shopify search tokenize ediyor — "12151955 - 7" icindeki "7" tag:7 ile matchleniyor.
    // Once aday listeyi al, sonra her aday icin tam tag kontrolu yap (/products/{handle}.js)
    fetch('/search/suggest.json?q=' + encodeURIComponent('tag:' + mk) + '&resources[type]=product&resources[limit]=20&resources[options][fields]=tag')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!prods.length) { CACHE[mk] = []; render([]); return; }
        var verifications = prods.map(function (p) {
          return fetch('/products/' + p.handle + '.js')
            .then(function (rr) { return rr.ok ? rr.json() : null; })
            .then(function (pj) {
              if (!pj || !Array.isArray(pj.tags)) return null;
              var hit = pj.tags.some(function (t) { return String(t).trim() === String(mk).trim(); });
              return hit ? p : null;
            }).catch(function () { return null; });
        });
        Promise.all(verifications).then(function (results) {
          var filtered = results.filter(Boolean);
          CACHE[mk] = filtered;
          render(filtered);
        });
      }).catch(function () {});
  }
  function scan() {
    document.querySelectorAll('[data-meoks-card-colors]:not([data-loaded="1"])').forEach(loadFor);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // Sonradan eklenen kartlar icin: sadece urun grid'i izle + debounce
  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    (window.requestIdleCallback || window.requestAnimationFrame)(function () {
      scanScheduled = false;
      scan();
    });
  }
  function attachGridObserver() {
    var grid = document.querySelector('.product-grid, results-list, [ref="grid"]');
    if (!grid) return false;
    new MutationObserver(scheduleScan).observe(grid, { childList: true, subtree: true });
    return true;
  }
  if (!attachGridObserver()) {
    // Grid henuz yoksa bir defaya mahsus body'yi izle, grid gelince devret
    var bootObs = new MutationObserver(function () {
      if (attachGridObserver()) { bootObs.disconnect(); scheduleScan(); }
    });
    bootObs.observe(document.body, { childList: true, subtree: true });
  }
})();
